<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">1物N価媒体プロモーション設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">アイテムコード</label>
              <div class="list-input-content">
                <select #cmb_ItemCode id="cmb_ItemCode" class="combo-box-required" forcedEnabledMode="None" tabindex="0"
                  [style.width.px]="175" [(ngModel)]="kymw0907Model.selectedItemCode" (change)="eventItemCode_CHANGEHandler()" [disabled]="isReadOnlyMode() || kymw0907Model.itemCodeListDisable">
                  <ng-template ngFor let-item [ngForOf]="kymw0907Model.itemCodeList">
                    <option value="{{item.ItemCode}}">{{item.ItemCode}}</option>
                  </ng-template>
                </select>
              </div>
              <label class="list-input-title">媒体</label>
              <div class="list-input-content">
                <app-versatile-combo-box #cmb_MediumType id="cmb_MediumType"
                  [(ngModel)]="kymw0907Model.mediumType" [listSource]="kymw0907Model.mediumTypeList"
                  valueField="MediumType" labelField="MediumName" [tabindex]="0" [visible]="true" [dspBothField]="true"
                  [autofocus]="false" forcedEnabledMode="true" (change)="common_CHANGEHandler();mediumType_CHANGEHandler()" [required]="true"
                  [style.width.rem]="17" [disabled]="isReadOnlyMode() || kymw0907Model.mediumTypeListDisable">
                </app-versatile-combo-box>
              </div>
              <label class="list-input-title">注文コード割当コード</label>
              <div class="list-input-content">
                <app-versatile-combo-box
                  [(ngModel)]="kymw0907Model.orderNumQuotaCode" [listSource]="kymw0907Model.orderNumQuotaCodeList"
                  valueField="OrderNumQuotaCode" labelField="OrderNumQuotaName" [tabindex]="0" [visible]="true" [dspBothField]="true"
                  [autofocus]="false" forcedEnabledMode="none" (change)="common_CHANGEHandler();nvalOrderNumQuotaCode_CHANGEHandler()" [required]="true"
                  [style.width.rem]="17" [disabled]="isReadOnlyMode()">
                </app-versatile-combo-box>
              </div>
              <label class="list-input-title">1物N価詳細区分</label>
              <div class="list-input-content">
                <app-versatile-combo-box
                  [(ngModel)]="kymw0907Model.nvalDetailDev" [listSource]="kymw0907Model.nvalDetailDevList"
                  valueField="Reserve1" labelField="CodeName" [tabindex]="0" [visible]="true" [dspBothField]="true"
                  [autofocus]="false" forcedEnabledMode="none" (change)="common_CHANGEHandler();" [required]="true"
                  [style.width.rem]="17" [disabled]="isReadOnlyMode()">
                </app-versatile-combo-box>
              </div>
              <label class="list-input-title">商品企画担当区分</label>
              <div class="list-input-content">
                <app-code-combo-box #cmb_Shkkktant_Kb id="cmb_Shkkktant_Kb" [subid]="'cmb_Shkkktant_Kb'"
                [codeDiv]="'ctp114'" [labelField]="'codeValueName'" [forcedEnabledMode]="'none'"
                [tabindex]="0" [blank]="true" [disabled]="isReadOnlyMode()" [required]="true"
                [(ngModel)]="this.kymw0907Model.shkkktantKb"></app-code-combo-box>
              </div>
              <label class="list-input-title">専用商品名</label>
              <div class="list-input-content">
                <app-not-null-text-input-coop-deli #txti_NvalPromotionGoodsName id="txti_NvalPromotionGoodsName"
                  [subid]="'txti_NvalPromotionGoodsName'" [required]="true" [maxChars]="15" [restrict]="'[ -￮]'"
                  [tabindex]="0" [fullOnly]="true" [(ngModel)]="kymw0907Model.nvalPromotionGoodsName"
                  [forcedEnabledMode]="'none'" [displayCountField]="false" [style.width.rem]="17" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-not-null-text-input-coop-deli>
              </div>
              <label class="list-input-title">専用商品名(カナ)</label>
              <div class="list-input-content">
                <app-not-null-text-input #txti_NvalPromotionGoodsNameKana [required]="true"
                  id="txti_NvalPromotionGoodsNameKana" [subid]="'txti_NvalPromotionGoodsNameKana'" [maxChars]="15"
                  [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [toUpperCase]="true" [tabindex]="0"
                  [(ngModel)]="kymw0907Model.nvalPromotionGoodsNameKana" [halfOnly]="true"
                  class="disabled-color-disabled" [displayCountField]="false" [style.width.rem]="17" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()" (input)="eventNvalPromotionGoodsNameKana_deleteCommaHandler()"
                  (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                </app-not-null-text-input>
              </div>
              <label class="list-input-title">専用規格名</label>
              <div class="list-input-content">
                <app-not-null-text-input-coop-deli #txti_NvalPromotionStandardName id="txti_NvalPromotionStandardName"
                  [subid]="'txti_NvalPromotionStandardName'" [required]="true" [maxChars]="10" [restrict]="'[ -￮]'"
                  [tabindex]="0" [fullOnly]="true" [(ngModel)]="kymw0907Model.nvalPromotionStandardName"
                  [forcedEnabledMode]="'none'" [displayCountField]="false" [style.width.rem]="12" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-not-null-text-input-coop-deli>
              </div>
              <label class="list-input-title">専用規格名(カナ)</label>
              <div class="list-input-content">
                <app-not-null-text-input #txti_NvalPromotionStandardNameKana [required]="true"
                  id="txti_NvalPromotionStandardNameKana" [subid]="'txti_NvalPromotionStandardNameKana'" [maxChars]="10"
                  [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [toUpperCase]="true" [tabindex]="0"
                  [(ngModel)]="kymw0907Model.nvalPromotionStandardNameKana" [halfOnly]="true"
                  class="disabled-color-disabled" [displayCountField]="false" [style.width.rem]="12" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()" (input)="eventNvalPromotionStandardNameKana_deleteCommaHandler()"
                  (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                </app-not-null-text-input>
              </div>
              <label class="list-input-title">値引区分</label>
              <div class="list-input-content">
                <app-versatile-combo-box #cmb_DiscountType [(ngModel)]="kymw0907Model.discountType" [listSource]="kymw0907Model.discountTypeList"
                  valueField="Code" [width]="120" labelField="Name" [required]="true" [tabindex]="0" [dspBothField]="true"
                  [visible]="true" [autofocus]="false" [forcedEnabledMode]="'none'" (change)="discountType_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-versatile-combo-box>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">注文コード</label>
              <div class="list-input-content">
                <input type="text" id="txti_OrderNum" maxlength="8" readonly [ngModel]="kymw0907Model.orderNum">
              </div>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">値引率</label>
              <div class="list-input-content">
                <app-versatile-combo-box #cmb_DiscountRate [(ngModel)]="kymw0907Model.discountRate" [listSource]="kymw0907Model.discountRateList"
                  valueField="Code" [width]="120" labelField="Name" [required]="true" [tabindex]="0" [dspBothField]="false"
                  [visible]="true" [autofocus]="false" [forcedEnabledMode]="'none'" (change)="eventDiscountRate_CHANGEHandler()" [disabled]="kymw0907Model.discountType==='1' || kymw0907Model.discountType==='0' || isReadOnlyMode()" [blank]="true">
                </app-versatile-combo-box>
              </div>
              <label class="list-input-title">供給単価</label>
              <div class="list-input-content">
                <app-not-null-text-input #txti_SupplyUnitPrice id="txti_SupplyUnitPrice" [subid]="'txti_SupplyUnitPrice'"
                  type="text" [maxChars]="7" [displayCountField]="false" [forcedEnabledMode]="'none'"
                  [restrict]="'[0-9]'" [tabindex]="0" [halfOnly]="true" [disabled]="isReadOnlyMode()"
                  [(ngModel)]="kymw0907Model.supplyPriceStandard" [style.width.rem]="7" (change)="eventCalcDiscountSupplyPrice_Handler();common_CHANGEHandler()"
                  (blur)="eventCalcDiscountSupplyPrice_Handler()">
                </app-not-null-text-input>
              </div>
              <label class="list-input-title">価格パターン</label>
              <div class="list-input-content">
                <app-code-combo-box #cmb_PricePattern id="cmb_PricePattern" [subid]="'cmb_PricePattern'"
                  [tabindex]="0" [required]="true" [codeDiv]="'ct355'" [labelField]="'codeValueName'"
                  [forcedEnabledMode]="'none'" [disabled]="isReadOnlyMode()" [blank]="false"
                  [(ngModel)]="kymw0907Model.selectPricePattern" (change)="eventPricePattern_CHANGEHandler()">
                  </app-code-combo-box>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">値引単価</label>
              <div class="list-input-content">
                <app-not-null-text-input #txti_DiscountUnitPrice id="txti_DiscountUnitPrice" [subid]="'txti_DiscountUnitPrice'"
                  type="text" [maxChars]="9" [displayCountField]="false" [forcedEnabledMode]="'none'"
                  [restrict]="'[0-9]'" [tabindex]="0" [disabled]="kymw0907Model.discountType==='2' || kymw0907Model.discountType==='0' || isReadOnlyMode()"
                  [(ngModel)]="kymw0907Model.discountUnitPrice" [style.width.rem]="7" [halfOnly]="true" (change)="eventDiscountUnitPrice_CHANGEHandler()">
                </app-not-null-text-input>
              </div>
              <label class="list-input-title">値引後供給単価</label>
              <div class="list-input-content">
                <input #txti_DiscountSupplyUnitPrice type="text" readonly id="txti_DiscountSupplyUnitPrice"
                  forcedEnabledMode="none" plessInputTextSub [style.width.rem]="7"
                  [restrict]="'[ -￮]'" [(ngModel)]="kymw0907Model.discountSupplyUnitPrice"/>
              </div>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">利用都県</label>
            <div class="list-input-content">
              <app-checkbox-label #chk_AllCoop [label]="'全生協'" id="chk_AllCoop" [subid]="'chk_AllCoop'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.allCoop" (change)="eventAllCoop_CLICKHandler()" [disabled]="isReadOnlyMode() || kymw0907Model.allCoopDisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopIB [label]="'い'" id="chk_CoopIB" [subid]="'chk_CoopIb'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture1Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopIBDisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopTO [label]="'と'" id="chk_CoopTO" [subid]="'chk_CoopTO'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture2Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopTODisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopGU [label]="'ぐ'" id="chk_CoopGU" [subid]="'chk_CoopGU'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture3Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopGUDisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopTI [label]="'ち'" id="chk_CoopTI" [subid]="'chk_CoopTI'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture4Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopTIDisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopSA [label]="'さ'" id="chk_CoopSA" [subid]="'chk_CoopSA'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture5Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopSADisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopTK [label]="'とう'" id="chk_CoopTK" [subid]="'chk_CoopTK'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture6Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopTKDisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopNA [label]="'な'" id="chk_CoopNA" [subid]="'chk_CoopNA'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture7Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopNADisable">
              </app-checkbox-label>
              <app-checkbox-label #chk_CoopNI [label]="'に'" id="chk_CoopNI" [subid]="'chk_CoopNI'" [tabindex]="0"
                [(ngModel)]="kymw0907Model.usePrefecture8Flg" (change)="setCoopAllCheck()" [disabled]="isReadOnlyMode() || kymw0907Model.coopNIDisable">
              </app-checkbox-label>
            </div>

            <label class="list-input-title">備考</label>
            <div class="list-input-content">
              <app-text-input-coop-deli #txti_Remarks id="txti_Remarks" [subid]="'txti_Remarks'" [restrict]="'[ -￮]'"
                [maxChars]="15" [forcedEnabledMode]="'none'" [tabindex]="0" [displayCountField]="false" [fullOnly]="true"
                [(ngModel)]="this.kymw0907Model.remarks" [style.width.rem]="17" [disabled]="isReadOnlyMode()">
              </app-text-input-coop-deli>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler()" [disabled]="isReadOnlyMode()"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
